import React from 'react';
import { PackageTypes, PackageTypeWords } from '~/lib/PackageHelpers';
import PackagePageTemplate from '~/components/packages/PackagePageTemplate';

const SubscriptionsIndexPage = ({}) => {
    return (
        <PackagePageTemplate
            type={PackageTypes.SUBSCRIPTION}
            singular={PackageTypeWords[PackageTypes.SUBSCRIPTION].singular}
            plural={PackageTypeWords[PackageTypes.SUBSCRIPTION].plural}
            introText="Subscriptions allow you to bill clients on a recurring basis."
            editPathBase="/subscriptions"
        />
    );
};

export default SubscriptionsIndexPage;
